import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { BankHoliday } from './models/BankHoliday';

export const BankHolidayStore = types
  .compose(
    getBaseStore<Instance<typeof BankHoliday>, Instance<typeof BankHoliday>>(
      BankHoliday,
      'bankHolidayId',
      'bankHoliday',
    ),
    types.model('BankHolidayStore', {}),
  )
  .actions((self) => {
    return {
      afterAttach: flow(function*() {
        yield self.loadList();
      }),
    };
  });

export type BankHolidayStoreType = Instance<typeof BankHolidayStore>;
